module.exports = __webpack_public_path__ + "static/img/govInfoLive.94799df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/govInfoLive.png
// module id = LBmr
// module chunks = 2